import React from 'react';
import CachedIcon from "@mui/icons-material/Cached";
import IconButton from "@material-ui/core/IconButton";
import {useDispatch, useSelector} from "react-redux";
import Service from "../services/Service";
import {getPortfolio} from "../store/actions";

const service = new Service();

export default function (){
    const data = useSelector(store => store.portfolio?.data)
    const dispatch = useDispatch();
    //const tinkoffAPI = data?.portfolio.tt;
    const handleClickUpdate = () => {
        service.tinkoffImportUpdate({'portfolio':data?.portfolio.id}).then((result) => {
            dispatch(getPortfolio(data?.portfolio.id));
        }).catch(() => {
            alert('Ошибка обновления');
        });
    };

    return(
        <>
        {data?.portfolio?.tt &&
            <IconButton
                aria-label="Синхронизация"
                onClick={handleClickUpdate}
            >
                <CachedIcon sx={{ color: "#fff" }} />
            </IconButton>
        }
        </>
    );
}